import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "w-full flex flex-col" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", { class: "font-bold" }, "Beteiligte:", -1)
const _hoisted_3 = {
  key: 0,
  class: "w-full max-h-52 bg-zewotherm-lightgrey rounded-b-lg p-2 flex flex-col items-start overflow-y-auto"
}
const _hoisted_4 = { class: "w-full rounded-l-lg flex flex-col outline-none" }
const _hoisted_5 = { class: "font-bold" }
const _hoisted_6 = { class: "w-full flex" }
const _hoisted_7 = { class: "h-full w-10 bg-zewotherm-lightgrey flex items-center justify-center rounded-r-lg" }
const _hoisted_8 = {
  key: 1,
  class: "w-full max-h-52 shadow-lg shadow-zewotherm-grey drop-shadow bg-zewotherm-lightgrey mt-2 rounded-lg p-2 flex flex-col items-start overflow-y-auto"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "font-bold text-lg mb-2" }, "Beteiligten Hinzufügen: ", -1)
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "w-full rounded-l-lg flex flex-col outline-none" }
const _hoisted_12 = { class: "font-bold" }
const _hoisted_13 = { class: "w-full flex" }
const _hoisted_14 = { class: "h-full w-10 flex items-center justify-center rounded-r-lg" }

import { onMounted, Ref, ref, watch } from 'vue'
import { useAddProject } from '@/store/addProject'
import { add, closeCircle } from 'ionicons/icons'
import { IonIcon, IonModal } from '@ionic/vue'
import Subcustomer from '@/interfaces/subcustomer/Subcustomer'
import axios, { AxiosResponse } from 'axios'
import SubcustomerProjectPage from '../SubcustomerProjectPage.vue'
import { useCompany } from '@/store/company'
import { useCurrentUser } from '@/store/currentUser'


export default /*#__PURE__*/_defineComponent({
  __name: 'SubcustomerInput',
  setup(__props) {

const addProjectStore = useAddProject()
const companyStore = useCompany()
const searchSubcustomer = ref("")
const subcustomerToChoose: Ref<Subcustomer[]> = ref([])
const openModalSubcustomer = ref(false)
const currentUserStore = useCurrentUser()

watch(() => searchSubcustomer.value, async(newValue, oldValue) => {
  if(newValue.length > 2) {
    const response = await axios.get(process.env.VUE_APP_CUSTOMER_API_BASE_URL + "subcustomer/?search=" + newValue + "/?company_id=" + companyStore.activeCompany.id, {
      headers: {
        Authorization: 'Bearer ' + currentUserStore.jwtKey
      }
    })
    let foundSubcustomers = response.data.data.filter((subcustomer: Subcustomer) => {
      let saveSubcustomer = true
      for(const savedSubcustomer of addProjectStore.projectActiveData.subcustomers) {
        if(savedSubcustomer._id === subcustomer._id) {
          saveSubcustomer = false
        }
      }
      return saveSubcustomer
    })
    subcustomerToChoose.value = foundSubcustomers
  } else {
    subcustomerToChoose.value = []
  }
})

function addOrRemoveSubcustomer(subcustomer: Subcustomer, clearSearch: boolean) {
  addProjectStore.addOrRemoveProjectActiveDataSubcustomer(subcustomer)
  if (clearSearch) searchSubcustomer.value = ""
}

async function getAndSetSubcustomerWithId(event: any) {
  if(!event.detail.data) return
  const response: AxiosResponse<any, any> = await axios.get(process.env.VUE_APP_CUSTOMER_API_BASE_URL + "subcustomer/" + event.detail.data + "/?company_id=" + companyStore.activeCompany.id, {
    headers: {
      Authorization: 'Bearer ' + currentUserStore.jwtKey
    }
  })
  const subcustomer: Subcustomer = response.data.data
  addOrRemoveSubcustomer(subcustomer, false)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(IonModal), {
      onWillDismiss: _cache[0] || (_cache[0] = ($event: any) => (openModalSubcustomer.value = false)),
      onDidDismiss: _cache[1] || (_cache[1] = ($event: any) => (getAndSetSubcustomerWithId($event))),
      "is-open": openModalSubcustomer.value,
      "swipe-to-close": true
    }, {
      default: _withCtx(() => [
        _createVNode(SubcustomerProjectPage)
      ]),
      _: 1
    }, 8, ["is-open"]),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", {
        class: _normalizeClass(["flex flex-row min-h-min h-10 bg-zewotherm-lightgrey mt-1", [
        _unref(addProjectStore).projectActiveData.subcustomers.length > 0 ? 'border-b-2 border-zewotherm-grey rounded-t-md' : 'rounded-lg',
        _unref(addProjectStore).errorResponse.subcustomers && _unref(addProjectStore).errorResponse.subcustomers.length > 0 ? 'border-2 border-red-500' : ''
      ]])
      }, [
        _withDirectives(_createElementVNode("input", {
          placeholder: "Suche",
          enterkeyhint: "next",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((searchSubcustomer).value = $event)),
          class: _normalizeClass([[_unref(addProjectStore).projectActiveData.subcustomers.length > 0 ? 'rounded-tl-lg': 'rounded-l-lg'], "w-0 placeholder-zewotherm-grey flex-grow h-full bg-zewotherm-lightgrey p-2 font-bold outline-none"])
        }, null, 2), [
          [_vModelText, searchSubcustomer.value]
        ]),
        _createElementVNode("div", {
          class: _normalizeClass([[
          _unref(addProjectStore).projectActiveData.subcustomers.length > 0 ? 'rounded-tr-lg border-zewotherm-grey border-l-2': 'rounded-r-lg', 
          subcustomerToChoose.value.length >= 1 ? 'border-zewotherm-grey border-l-2' : ''
        ], "w-10 h-full flex items-center justify-center bg-zewotherm-lightgrey"])
        }, [
          _createVNode(_unref(IonIcon), {
            icon: _unref(add),
            onClick: _cache[3] || (_cache[3] = ($event: any) => (openModalSubcustomer.value = true)),
            class: "w-8 h-8 cursor-pointer"
          }, null, 8, ["icon"])
        ], 2)
      ], 2),
      (_unref(addProjectStore).projectActiveData.subcustomers.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(addProjectStore).projectActiveData.subcustomers, (subcustomer) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "w-full flex flex-row items-center justify-between my-3 first:mt-0 last:mb-0",
                key: subcustomer._id
              }, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("label", _hoisted_5, _toDisplayString(subcustomer.name) + " (" + _toDisplayString(subcustomer.city) + ")", 1),
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("label", null, "(" + _toDisplayString(subcustomer.function.name) + ")", 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_unref(IonIcon), {
                    icon: _unref(closeCircle),
                    onClick: ($event: any) => (addOrRemoveSubcustomer(subcustomer, false)),
                    class: "w-6 h-6 cursor-pointer"
                  }, null, 8, ["icon", "onClick"])
                ])
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (subcustomerToChoose.value.length >= 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _hoisted_9,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subcustomerToChoose.value, (subcustomer, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "w-full flex flex-row items-center justify-between my-3 first:mt-0 last:mb-0",
                onClick: ($event: any) => (addOrRemoveSubcustomer(subcustomer, true)),
                key: index
              }, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("label", _hoisted_12, _toDisplayString(subcustomer.name) + " (" + _toDisplayString(subcustomer.city) + ")", 1),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("label", null, "(" + _toDisplayString(subcustomer.function.name) + ")", 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_unref(IonIcon), {
                    icon: _unref(add),
                    style: _normalizeStyle('color: ' + _unref(companyStore).activeCompany.color),
                    class: "w-6 h-6 cursor-pointer"
                  }, null, 8, ["icon", "style"])
                ])
              ], 8, _hoisted_10))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(addProjectStore).errorResponse.subcustomers, (errorMsg, index) => {
        return (_openBlock(), _createElementBlock("p", {
          class: "text-red-500",
          key: index
        }, _toDisplayString(errorMsg), 1))
      }), 128))
    ])
  ], 64))
}
}

})